import { render, staticRenderFns } from "./AccommodationServiceForm.vue?vue&type=template&id=b1ce63e8&"
import script from "./AccommodationServiceForm.vue?vue&type=script&lang=js&"
export * from "./AccommodationServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationServiceForm.vue?vue&type=style&index=0&id=b1ce63e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports